export default __webpack_public_path__ + "static/media/summerchallenge01.5b6a8ae5.jpg";